import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  return (
    <section className="not-found-page">
      <div>
        <span>404</span>
        <h1>Page not found</h1>
        <p>The page you requested is not available. Use the links below to continue through Mailsnappy's public marketing pages.</p>
        <div className="not-found-actions">
          <Link to="/">Go to homepage</Link>
          <Link to="/features">View email marketing features</Link>
        </div>
      </div>
    </section>
  );
}
